import React from "react";
import flowers from "../data/bucheteDeVara";
import FlowerContainer from "../components/FlowerContainer";

const BucheteDeVara = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Buchete De Vara"
      subtitle="Flori vibrante și parfumate, care aduc bucuria verii în orice moment."
      storageKey="BUCHETE_DE_VARA_SCROLL_POSITION"
    />
  );
};

export default BucheteDeVara;
